module.exports = __webpack_public_path__ + "static/question-bg-39424d1961eb22feb3084d1e24f4f5c0.jpg";